const mutationsTypes = {
  // common
  COMMON_SET_DISPLAY_API_ALERT: 'commonSetDisplayApiAlert',
  // Auth
  AUTH_SET_LOGIN: 'authSetLogin',
  AUTH_SET_MAIL_VERIFY_URL: 'authSetMailVerifyUrl',
  // products
  ITEM_SET_ITEM_INFO_LIST: 'itemSetItemInfoList',
  ITEM_SET_TOTAL_ROWS: 'itemSetTotalRows',
  ITEM_SET_PERPAGES: 'itemSetItemInfoListPerPages',
  // customer
  CUSTOMER_SET_CUSTOMER_INFO_LIST: 'customerSetCustomerInfoList',
  CUSTOMER_SET_TOTAL_ROWS: 'customerSetTotalRows',
  CUSTOMER_SET_PERPAGES: 'customerSetPerPages',
  CUSTOMER_SET_CUSTOMER_ID_NAME_LIST: 'customerSetCustomerIdNameList',
  // supplier
  SUPPLIER_SET_SUPPLIERS: 'supplierSetSuppliers',
  SUPPLIER_SET_SUPPLIER_ID_NAME_LIST: 'supplierSetSupplierIdNameList',
  SUPPLIER_SET_SUGGESTED_RECIEVING_LOCATION_LIST:
    'supplierSetSuggestedReceivingLocationList',
  SUPPLIER_SET_SUPPLIER_ID_NAME_AND_DESCRIPTION_LIST:
    'supplierSetSupplierIdNameAndDescriptionList',
  // sales
  SALE_SET_SALES_REGISTER_CONFIRM_DIALOG: 'saleSetRegisterConfirmDialog',
  SALE_SET_SALES_REGISTER_PARMS: 'saleSetRegisterParams',
  SALE_SET_SALE_HISTORY: 'saleSetSaleHistory',
  SALE_SET_SALE_PAYMENT_LIST: 'saleSetSalePaymentList',
  SALE_SET_RACKNUMBER_BY_PRODUCT: 'saleSetRacknumberByProduct',
  SALE_SET_SALE_DETAIL: 'saleSetSaleDetail',
  SALE_BULK_OPERATION_FLG: 'salebulkOperationFlg',
  // user
  USER_SET_USER_INFO: 'userSetUserInfo',
  USER_SET_USER_LIST: 'userSetUserList',
  USER_SET_UNREAD_NOTICE_COUNT: 'userSetUnreadNoticeCount',
  PRODUCT_EXPIRED_DATE_ALERT_UNREADS: 'productExpiredDateAlertUnreads',
  USER_SET_TUTORIAL_STATUS: 'userSetTutorialStatus',
  // product
  PRODUCT_SET_PRODUCT_AND_STOCK_LIST: 'productSetProductAndStockList',
  PRODUCT_SET_PRODUCT_LIST: 'productSetProductList',
  PRODUCT_SET_MAKER_LIST: 'productSetMakerList',
  // order
  ORDER_SET_ORDER_LIST: 'orderSetOrderList',
  ORDER_SET_ORDER_INCOMPLETE_LIST: 'orderSetOrderIncompleteList',
  ORDER_SET_ORDER_DETAIL_LIST: 'orderSetOrderDetailList',
  ORDER_SET_ORDER_PAYMENT_LIST: 'orderSetOrderPaymentList',
  ORDER_BULK_OPERATION_FLG: 'orderbulkOperationFlg',

  // common
  COMMON_SET_CONSUMPTION_TAX_LIST: 'commonSetConsumptionTaxList',
  COMMON_SET_CURRENCY_LIST: 'commonSetCurrencyList',
  COMMON_SET_COUNTRY_LIST: 'commonSetCountryList',
  COMMON_SET_COUNTRY_CALLING_CODE_LIST: 'commonSetCountryCallingCodeList',
  COMMON_SET_PRODUCT_CATEGORY_LIST: 'commonSetProductCategoryList',
  COMMON_SET_CUSTOMER_CATEGORY_LIST: 'commonSetCustomerCategoryList',
  COMMON_SET_BRAND_LIST: 'commonSetBrandList',
  // loading
  LOADING_SET_LOADING_LIST: 'loadingSetLoadingList',
  LOADING_CANCEL_FLG: 'loadingCancelFlg',
  // storage
  STORAGE_SET_STORAGE_LIST: 'storageSetStorageList',
  // ship
  SHIP_SET_SHIP_LIST: 'shipSetShipList',
  SHIP_GET_SHIP_DELIVERY_LIST: 'getShipDeliveryList',
  // note phrase
  NOTE_PHRASE_SET_NOTE_PHRASE_LIST: 'notePhraseSetNotePhraseList',
  // payment method
  PAYMENT_METHOD_SET_PAYMENT_METHOD_LIST: 'paymentMethodSetPaymentMethodList',
  // refund
  REFUND_SET_REFUND_LIST: 'refundSetRefundList',
  // stockMove
  STOCK_MOVE_SET_STOCK_MOVE_REASON_LIST: 'stockMoveSetStockMoveReasonList',
  STOCK_MOVE_SET_STOCK_MOVE_LIST: 'stockMoveSetStockMoveList',
  // stockAdjust
  STOCK_ADJUST_SET_STOCK_ADJUST_REASON_LIST:
    'stockAdjustSetStockAdjustReasonList',
  STOCK_ADJUST_SET_STOCK_ADJUST_LIST: 'stockAdjustSetStockAdjustList',
  // transferAccount
  TRANSFER_ACCOUNT_SET_TRANSFER_ACCOUNT_LIST:
    'transferAccountSetTransferAccountList',
  // combinedBill
  COMBINED_BILL_SET_COMBINED_BILL_LIST: 'combinedBillSetCombinedBillList',
  COMBINED_BILL_SET_COMBINED_BILL_DOWNLOAD: 'combinedBillSetCombinedBillDownload',
  // jdproduct
  JDPRODUCT_SET_JDPRODUCT_LIST: 'jdproductSetJdproductList',
  JDPRODUCT_SET_META: 'jdproductSetJMeta',
  JDPRODUCT_SET_JDPRODUCT_MAP: 'jdproductSetJdproductMap',
  // oftenUse
  OFTEN_USE_SET_LIST: 'oftenUseSetList',
  OFTEN_USE_SET_SCREEN_LIST: 'oftenUseSetScreenList',
  // uploadUrl
  FILE_SET_UPLOAD_URL: 'fileSetUploadUrl',
  // externalSystemCsvUpload
  FILE_SET_CSV_UPLOAD_TOTAL: 'fileSetCsvUploadTotal',
  FILE_SET_CSV_UPLOAD_ERROR_LIST: 'fileSetCsvUploadErrorList',
  FILE_SET_CSV_UPLOAD_HISTORY_LIST: 'fileSetCsvUploadHistoryList',
  // notice
  NOTICE_SET_NOTICE_LIST: 'noticeSetNoticeList',
  // balanceOfPayment
  BALANCE_OF_PAYMENT_SET_BALANCE_OF_PAYMENT_LIST:
    'balanceOfPaymentSetBalanceOfPaymentList',
  // aggregateData(kpi)
  AGGREGATE_DATA_SET_AGGREGATE_DATA_LIST: 'aggregateData',
  // fx
  FX_SET_FX_RATE_LIST: 'fxSetFxRateList',
  // shop
  SHOP_SET_SHOP_LIST: 'shopSetShopList',
  // platform
  PLATFORM_SET_PLATFORM_LIST: 'platformSetPlatformList',

  // lang
  LANG_SET_TYPE: 'langSetType',
  // UI
  UI_SET_SUCCESS_MODAL: 'uiSetSuccessModal',
  UI_SET_ERROR_MODAL: 'uiSetErrorModal',
  UI_SET_PAGE: 'uiSetPage',
  UI_SET_PAGE_COUNT: 'uiSetPageCount',
  // UI_SET_FILTER: 'uiSetFilter'
  // ledgerSheet
  LEDGER_SHEET_HEADER: 'ledgerSheet',
  // loading
  SET_IS_LOADING: 'setIsLoading',
  RESET_IS_LOADING: 'resetIsLoading',
  // Nextengine
  NEXTENGINE_SET_EC_GOODS_LIST: 'nextengineSetEcGoodsList',
  NEXTENGINE_SET_EC_RECEIVEORDER_LIST: 'nextengineSetEcReceiveorderList',
  NEXTENGINE_SET_NEXTENGINE_COOPERATE_CONFIG_DATA:
    'nextengineSetNextengineCooperateConfig'
}

export default mutationsTypes
